export const TESTIMONIALS = [
  {
    id: 'sarah-chen',
    name: 'Sarah Chen',
    role: 'Founder',
    company: 'BrightPath Studio',
    quote:
      'ZACK Software Solutions helped us bring structure to our online presence and made our launch process far more organized and scalable.',
    rating: 5,
    avatarText: 'SC',
    avatarStart: '#7fb5ff',
    avatarEnd: '#2f5fcf',
  },
  {
    id: 'michael-torres',
    name: 'Michael Torres',
    role: 'Small Business Owner',
    company: 'Torres Consulting',
    quote:
      'Their support with website setup, workflows, and digital visibility gave us a more professional foundation from day one.',
    rating: 5,
    avatarText: 'MT',
    avatarStart: '#8dc9ff',
    avatarEnd: '#3a6ee0',
  },
  {
    id: 'priya-nair',
    name: 'Priya Nair',
    role: 'Operations Lead',
    company: 'Northline Services',
    quote: 'The engagement felt thoughtful, technical, and tailored to how our business actually operates.',
    rating: 5,
    avatarText: 'PN',
    avatarStart: '#96b6ff',
    avatarEnd: '#3f63be',
  },
  {
    id: 'daniel-brooks',
    name: 'Daniel Brooks',
    role: 'Startup Founder',
    company: 'Elevate Works',
    quote: 'ZACK Software Solutions translated our ideas into a cleaner digital system that made execution much easier.',
    rating: 5,
    avatarText: 'DB',
    avatarStart: '#9ac8ff',
    avatarEnd: '#3565d7',
  },
  {
    id: 'jessica-miller',
    name: 'Jessica Miller',
    role: 'Brand Manager',
    company: 'Miller & Co',
    quote: 'From content organization to site improvements, the whole experience felt polished and dependable.',
    rating: 5,
    avatarText: 'JM',
    avatarStart: '#a3c3ff',
    avatarEnd: '#4060c5',
  },
];
